var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNetworkingInPractice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-107 -404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.062 414.969 130.562 414.969 130.562 413.75C130.562 412.856 129.831 412.125 128.938 412.125L111.875 412.125C110.981 412.125 110.25 412.856 110.25 413.75L110.25 424.719C110.25 425.612 110.981 426.344 111.875 426.344L114.312 426.344 114.312 430.406 118.375 426.344 120.812 426.344 120.812 418.219C120.812 416.431 122.275 414.969 124.062 414.969Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.125 416.594 124.062 416.594C123.169 416.594 122.438 417.325 122.438 418.219L122.438 429.188C122.438 430.081 123.169 430.812 124.062 430.812L134.625 430.812 138.688 434.875 138.688 430.812 141.125 430.812C142.019 430.812 142.75 430.081 142.75 429.188L142.75 418.219C142.75 417.325 142.019 416.594 141.125 416.594Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkingInPractice);
export default __webpack_public_path__ + "static/media/icon-networking-in-practice.16956a875725b4a3b57d06d6022279dd.svg";
export { ForwardRef as ReactComponent };